// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "垃圾焚烧发电技术",
      "tec": "王树群",
      "week": "8-15周",
      "add": "教学楼B座420能动"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "循环流化床锅炉",
      "tec": "刘耀鑫",
      "week": "8-13周",
      "add": "教学楼B座323能动"
    },
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "8-13周",
      "add": "教学楼B座323能动"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "集控运行",
      "tec": "傅玉栋孙卓伦",
      "week": "1-3,6,8-13周",
      "add": "教学楼C座308教务"
    },
    0,
    0,
    {
      "sub": "压力容器安全技术",
      "tec": "付洪亮唐堃",
      "week": "1-8周",
      "add": "教学楼C座111教务"
    }
  ],
  "4": [
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "8-13周",
      "add": "教学楼B座323能动"
    },
    {
      "sub": "储能技术",
      "tec": "李楠",
      "week": "8-15周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "水轮机设备及系统",
      "tec": "高宇赵傲",
      "week": "8-15周",
      "add": "教学楼B座324能动"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "循环流化床锅炉",
      "tec": "刘耀鑫",
      "week": "8-13周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "集控运行",
      "tec": "傅玉栋孙卓伦",
      "week": "1-3,6,8-13周",
      "add": "教学楼C座306教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
